import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api";
import { showLoading } from "../slice/loadingSlice";

const clientManagementAsyncThunk = (method, type, contentType, url) =>
    createAsyncThunk(type, async (payload, thunkAPI) => {
      const { data } = payload;
      const { dispatch } = thunkAPI;
      const token = localStorage.getItem("token");
      const apiRequest = {
        method: method,
        headers: token
          ? {
              "Content-Type": contentType,
              Authorization: "Token " + localStorage.getItem("token"),
            }
          : { "Content-Type": contentType },
        url: `${baseUrl}${url}`,
        data,
      };
  
      try {
        dispatch(showLoading.actions.toggleLoading(true));
        const res = await apiCall(apiRequest, dispatch);
        const response = res.data;

        console.log("response", response);
  
        dispatch(showLoading.actions.toggleLoading(false));
  
        if (response.statusFlag === true) {
          console.log(`login action ------ ${type}`, response);
          return response;
        } else {
          console.error(`account action - ${type}`, response);
  
          // Check if there is an error code in the response
          const errorCode = response.message;
  
          // You can throw a custom error with the error code
          throw new Error(errorCode);
        }
      } catch (error) {
        dispatch(showLoading.actions.toggleLoading(false));
        throw error;
      }
    });

export const listAllVendors = clientManagementAsyncThunk(
    "post",
    "listAllVendors",
    "application/json",
    "valiantinfo_admin/client_vendor_service/list_all_vendors/"
  );

export const companyInformationDetails = clientManagementAsyncThunk(
    "post",
    "companyInformationDetails",
    "application/json",
    "valiantinfo_admin/client_vendor_service/Company_info_details/"
)
export const uploadMspDocument = clientManagementAsyncThunk(
    "post",
    "uploadMspDocument",
    "multipart/formdata",
    "/valiantinfo_app/Client_information/update_vendor_documents/"
)
export const getClientPaymentDetails = clientManagementAsyncThunk(
    "post",
    "getClientPaymentDetails",
    "application/json",
    "valiantinfo_admin/admin_billing_service/admin_fetch_client_billing_details/"
)
export const updateClientDetails = clientManagementAsyncThunk(
    "patch",
    "updateClientDetails",
    "multipart/form-data",
    "valiantinfo_admin/vendor_settings/update_client_Payment_cancellation_details/"
)
export const getClientDetails = clientManagementAsyncThunk(
    "get",
    "getClientDetails",
    "application/json",
    "valiantinfo_admin/admin_dashboard_service/fetch_master_name/"
)
export const getClientChecksList = clientManagementAsyncThunk(
    "post",
    "getClientChecksList",
    "application/json",
    "valiantinfo_admin/admin_dashboard_service/fetch_master_package_name/"
)
export const postUpdatedCheckList = clientManagementAsyncThunk(
    "post",
    "postUpdatedCheckList",
    "application/json",
    "valiantinfo_admin/admin_dashboard_service/register_vendor/"
)
